import { useEffect, useRef } from 'react';
import { SessionShell, SessionHeader, SessionLayout, NotesDrawer, useSessionChrome } from '../../ui';
import { useNotes } from '../../context/notesContext';
import { useSessionState } from '../../context/sessionStateContext';
import { useSessionPeople, useConfirmEndSession, useClinicianNavigation, buildMenuItems } from './hooks';

// Clinician chrome for every step after the lobby (C2 onwards): IBISengage header with the step
// title, See Notes and the hamburger menu; main panel + nav row (End Session left) + video strip.
// Screens set the title with setTitle (MainPanelContent passes it down) and put their buttons in
// the nav row with <SessionActions/>.
export const ClinicianSessionFrame = ({ activeTab, setActiveTab, children }) => {
  const people = useSessionPeople();
  const { title } = useSessionChrome();
  const { showNotes, setShowNotes } = useNotes();
  const endSession = useConfirmEndSession();
  const navigate = useClinicianNavigation(activeTab, setActiveTab);
  const { patch } = useSessionState();

  // Mirror the clinician's step into the shared session state (lets the patient's app and a
  // re-joining clinician land on the same step).
  const lastStep = useRef(null);
  useEffect(() => {
    if (!activeTab || activeTab === lastStep.current || activeTab === 'welcomeScreen') return;
    lastStep.current = activeTab;
    patch({ step: activeTab }).catch(() => {});
  }, [activeTab, patch]);

  const consultation = activeTab === 'consultationView';

  return (
    <SessionShell
      fixed
      header={
        <SessionHeader
          title={title}
          onSeeNotes={() => setShowNotes(true)}
          menuItems={buildMenuItems({ activeTab, onNavigate: navigate, onEnd: endSession })}
        />
      }
    >
      <SessionLayout
        endAction={{ label: 'End Session', onClick: endSession }}
        showVideo={!consultation}
        panelProps={consultation ? { padding: '0' } : undefined}
        video={{
          localLabel: people.localLabel,
          localName: people.localName,
          remoteLabel: people.remoteLabel,
          remoteName: people.remoteName,
          localTileProps: { showMenu: true },
        }}
      >
        {children}
      </SessionLayout>
      <NotesDrawer
        open={Boolean(showNotes)}
        onClose={() => setShowNotes(false)}
        appointmentId={people.appointmentId}
        currentUserId={people.currentUserId}
        patientName={people.patientName}
      />
    </SessionShell>
  );
};

export default ClinicianSessionFrame;
